import {combineReducers} from 'helpers';
import {index} from './index';
import {emotionsMeter} from './emotions-meter';

export const diary = combineReducers({ index, emotionsMeter });
